export default {

  thousandSeparator(count, locale) {
    if (count && locale) {
      return count.toLocaleString(locale);
    }
    return count.toLocaleString('en-US');
  },

};
